<template>
  <div class="webcall__text">
    <p>{{ $t(`${namespace}.webcallPermissionMessage`) }}</p>
    <v-btn
      :loading="loading"
      :disabled="loading"
      color="white"
      round
      depressed
      @click="handleClick"
    >
      {{ $t(`${namespace}.webcallPermissionButton`) }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'CurrentPositionText',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.NewWebCallPage'
    }
  },
  methods: {
    handleClick () {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.webcall__text {
  height: 100%;
}

.webcall__text {
  align-items: center;
  background-color: rgba(0,0,0,.6);
  color: #fff;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  justify-content: center;
  right: 0;
  text-align: center;
  top: 0;
  position: absolute;
  z-index: 1;

  p {
    max-width: 280px;
  }
}
</style>
